import RentCalculator from './rent-calculator';

export default RentCalculator;
